import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/mobile-interview',
    name: 'MobileInterview',
    component: () => import('../views/MobileInterview.vue'),
    meta: { title: '面试打分', noAuth: true }
  },
  {
    path: '/host-tile',
    name: 'HostTile',
    component: () => import('../views/HostTile.vue'),
    meta: { title: '主持人（平铺）', noAuth: true }
  },
  {
    path: '/',
    component: () => import('../layout/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '首页概览', icon: 'el-icon-s-home' }
      },
      {
        path: 'candidate',
        name: 'Candidate',
        component: () => import('../views/Candidate.vue'),
        meta: { title: '候选人管理', icon: 'el-icon-user' }
      },
      {
        path: 'position',
        name: 'Position',
        component: () => import('../views/Position.vue'),
        meta: { title: '岗位管理', icon: 'el-icon-office-building' }
      },
      {
        path: 'question',
        name: 'Question',
        component: () => import('../views/Question.vue'),
        meta: { title: '题库管理', icon: 'el-icon-document' }
      },
      {
        path: 'paper',
        name: 'Paper',
        component: () => import('../views/Paper.vue'),
        meta: { title: '面试试卷', icon: 'el-icon-notebook-2' }
      },
      {
        path: 'prompt',
        name: 'Prompt',
        component: () => import('../views/Prompt.vue'),
        meta: { title: '提示词管理', icon: 'el-icon-chat-line-square' }
      },
      {
        path: 'evaluator',
        name: 'Evaluator',
        component: () => import('../views/Evaluator.vue'),
        meta: { title: '评委管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'session',
        name: 'Session',
        component: () => import('../views/Session.vue'),
        meta: { title: '面试场次', icon: 'el-icon-date' }
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('../views/Report.vue'),
        meta: { title: '报告管理', icon: 'el-icon-data-analysis' }
      },
      {
        path: 'organization',
        name: 'Organization',
        component: () => import('../views/Organization.vue'),
        meta: { title: '组织架构', icon: 'el-icon-s-grid' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/User.vue'),
        meta: { title: '用户管理', icon: 'el-icon-s-tools' }
      },
      {
        path: 'audit',
        name: 'Audit',
        component: () => import('../views/Audit.vue'),
        meta: { title: '操作日志', icon: 'el-icon-notebook-2' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || '面试智能辅助系统') + ' - 面试系统'
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else if ((to.meta && to.meta.noAuth) || (to.path && to.path.includes('mobile-interview')) || (to.path && to.path.includes('host-tile'))) {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
